import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const CustomerRoutes = defineRoute({
    record: {
        route: {
            path: "/customer",
            component: () => loadView(import("./CustomerTable.vue")),
        },
    },
    create: {
        route: {
            path: "/customer/create",
            component: () => loadView(import("./CustomerCreate.vue")),
        },
        debug: true,
    },
    update: {
        route: {
            path: "/customer/update/:id",
            component: () => loadView(import("./CustomerUpdate.vue")),
        },
        build(id: string) {
            return `/customer/update/${id}`;
        },
    },
});
